/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospitalManager } from 'app/shared/model/hospital-manager.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IOperationTheatre } from 'app/shared/model/operation-theatre.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';

export interface ISurgicalAppointmentAttributeType {
  id?: string;
  name?: string;
  description?: string | null;
  format?: string | null;
  sortOrder?: number | null;
  retiredReason?: string | null;
  retired?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  addedBy?: IHospitalManager | null;
  modifiedBy?: IHospitalManager | null;
  hospital?: IHospital | null;
  theatre?: IOperationTheatre | null;
  procedure?: IHospitalProcedure | null;
}

export const defaultValue: Readonly<ISurgicalAppointmentAttributeType> = {
  retired: false,
  active: false,
};
